export const formatAddressLineTwo = ({
	city,
	state,
	postalCode,
}: {
	city?: null | string;
	state?: null | string;
	postalCode?: null | string;
}) => {
	const cityState = [city, state].filter(Boolean).join(", ");
	const cityStatePostal = [cityState, postalCode].filter(Boolean).join(" ");
	return cityStatePostal;
};

export const parseQuoteAddressLineTwo = (addressLineTwo?: string | null) => {
	const normalized = addressLineTwo?.trim();
	if (!normalized) {
		return {
			city: null,
			state: null,
			postalCode: null,
		};
	}

	// Expected quote format: "City, ST 12345"
	const matched = normalized.match(/^(.+?),\s*([A-Za-z]{2})(?:\s+(.+))?$/);
	if (matched) {
		const [, city, state, postalCode] = matched;
		return {
			city: city.trim() || null,
			state: state.trim().toUpperCase() || null,
			postalCode: postalCode?.trim() || null,
		};
	}

	const [cityPart, remainder] = normalized.split(",", 2);
	const [statePart, ...postalParts] = (remainder ?? "").trim().split(/\s+/).filter(Boolean);
	return {
		city: cityPart?.trim() || null,
		state: statePart?.trim().toUpperCase() || null,
		postalCode: postalParts.join(" ").trim() || null,
	};
};

/**
 * Returns the attention line to show under the insured name when present.
 * Use this for quote document, policy doc, mail, etc.
 */
export const formatAttentionLine = (attention?: null | string): string => {
	const t = attention?.trim();
	return t ? t : "";
};
